import { TaskStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
/** Délai au jour (`yyyy-MM-dd`), sans heure : `null` l'efface. */
const dueDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date invalide.')
    // « 2026-02-31 » passe la forme mais n'existe pas : le jour relu doit être le même.
    .refine((day) => {
    const date = new Date(`${day}T00:00:00.000Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().startsWith(day);
}, 'Date invalide.')
    .nullable();
export const createTaskSchema = z.object({
    /** Tâche née d'une alerte : l'alerte est passée en lue à la création. */
    alertId: z.string().min(1).optional(),
    assigneeId: z.string().min(1, 'Choisissez à qui attribuer la tâche.'),
    body: z.string().trim().max(5000).nullable().optional(),
    /** Visible seulement de l'auteur et du destinataire. */
    confidential: z.boolean().optional(),
    dueDate: dueDateSchema.optional(),
    title: z.string().trim().min(1, 'Veuillez saisir un titre.').max(200),
});
export const updateTaskSchema = createTaskSchema
    .omit({ alertId: true })
    .partial()
    .extend({ status: z.nativeEnum(TaskStatus).optional() });
/** Marquer vues des tâches reçues : celles-là, ou toutes les nouvelles si absent. */
export const markTasksSeenSchema = z.object({
    taskIds: z.array(z.string().min(1)).min(1).optional(),
});
